module.exports = "/_next/static/images/micasadeco_menu_top-43555f54407df3888d24cc9a49ea42c5.jpg";